<template>
  <div class="pagination">
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="100"
        layout="prev, pager, next, jumper"
        :page-count="totalPage"
        >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    totalPage: Number,
  },
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.$emit('pageChange', val)
    }
  }
}
</script>

<style lang="scss" >
  .pagination{
    padding: 90px 0;
    text-align: right;
    .el-pager {
      li{
        background: none;
        //color: #fff;
        &.active{
          color: #EB6100;
        }
      }

      .el-pagination__editor .el-input__inner{
        border-radius: 0;
      }
    }

    .el-pagination{
      .btn-next, .btn-prev{
        background: none;
      }
    }
  }
</style>
